import Vue from 'vue'
import VueApollo from 'vue-apollo'
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  concat
} from '@apollo/client/core'

import store from './store'
import logToConsole from '@/utils/consoleHelper'

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'
})

// Install the vue plugin
Vue.use(VueApollo)

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      authorization: store.getters.isAuthenticated
        ? `Bearer ` + store.getters.getAuthToken
        : null
    }
  })

  return forward(operation)
})

// Create apollo client
const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  addTypename: false,
  cache: new InMemoryCache({
    addTypename: false
  }),
  name: 'ATMOS-Frontend',
  version: '0.1',
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  }
})

export { apolloClient as ApolloClient }

// Call this in the Vue app file
export function createProvider() {
  // Create vue apollo provider
  return new VueApollo({
    defaultClient: apolloClient,
    errorHandler(error) {
      logToConsole(error.message, 'fatal')
    }
  })
}

// Call this when user log in and out to clear the cache
export async function clearApolloStore() {
  try {
    apolloClient.resetStore().then(() => {})
  } catch (error) {
    logToConsole(error.message, 'error')
  }
}
